/**
 * ForStraction service API
 * Lead your organisation’s full potential to creating results
 *
 * OpenAPI spec version: 2.0.1639219082
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'));
  } else {
    // Browser globals (root is window)
    if (!root.ForStractionServiceApi) {
      root.ForStractionServiceApi = {};
    }
    root.ForStractionServiceApi.StrategicProgramConnection = factory(root.ForStractionServiceApi.ApiClient);
  }
}(this, function(ApiClient) {
  'use strict';




  /**
   * The StrategicProgramConnection model module.
   * @module model/StrategicProgramConnection
   * @version 2.0.1639219082
   */

  /**
   * Constructs a new <code>StrategicProgramConnection</code>.
   * @alias module:model/StrategicProgramConnection
   * @class
   */
  var exports = function() {
    var _this = this;








  };

  /**
   * Constructs a <code>StrategicProgramConnection</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/StrategicProgramConnection} obj Optional instance to populate.
   * @return {module:model/StrategicProgramConnection} The populated <code>StrategicProgramConnection</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (data.hasOwnProperty('SourceProgramID')) {
        obj['SourceProgramID'] = ApiClient.convertToType(data['SourceProgramID'], 'Integer');
      }
      if (data.hasOwnProperty('StrategyDescriptionID')) {
        obj['StrategyDescriptionID'] = ApiClient.convertToType(data['StrategyDescriptionID'], 'Integer');
      }
      if (data.hasOwnProperty('StrategicGoalID')) {
        obj['StrategicGoalID'] = ApiClient.convertToType(data['StrategicGoalID'], 'Integer');
      }
      if (data.hasOwnProperty('StrategicGoalMilestoneID')) {
        obj['StrategicGoalMilestoneID'] = ApiClient.convertToType(data['StrategicGoalMilestoneID'], 'Integer');
      }
      if (data.hasOwnProperty('StrategicSelectionID')) {
        obj['StrategicSelectionID'] = ApiClient.convertToType(data['StrategicSelectionID'], 'Integer');
      }
      if (data.hasOwnProperty('TargetProgramID')) {
        obj['TargetProgramID'] = ApiClient.convertToType(data['TargetProgramID'], 'Integer');
      }
      if (data.hasOwnProperty('ID')) {
        obj['ID'] = ApiClient.convertToType(data['ID'], 'Integer');
      }
    }
    return obj;
  }

  /**
   * @member {Integer} SourceProgramID
   * @default 0
   */
  exports.prototype['SourceProgramID'] = 0;
  /**
   * @member {Integer} StrategyDescriptionID
   */
  exports.prototype['StrategyDescriptionID'] = undefined;
  /**
   * @member {Integer} StrategicGoalID
   */
  exports.prototype['StrategicGoalID'] = undefined;
  /**
   * @member {Integer} StrategicGoalMilestoneID
   */
  exports.prototype['StrategicGoalMilestoneID'] = undefined;
  /**
   * @member {Integer} StrategicSelectionID
   */
  exports.prototype['StrategicSelectionID'] = undefined;
  /**
   * @member {Integer} TargetProgramID
   */
  exports.prototype['TargetProgramID'] = undefined;
  /**
   * @member {Integer} ID
   * @default 0
   */
  exports.prototype['ID'] = 0;



  return exports;
}));


